import SubmitEditorRoot from "./SubmitEditorRoot";

export default SubmitEditorRoot;
